import { Component } from '@angular/core';

@Component({
  selector: 'app-interviewer',
  templateUrl: './interviewer.component.html',
  styleUrl: './interviewer.component.scss'
})
export class InterviewerComponent {

}
